// extracted by mini-css-extract-plugin
var _1 = "CurrencySelectControlContent-moduleCurrencySelectControlContent__udewF";
var _2 = "CurrencySelectControlContent-modulecurrency__UA1Tm";
export { _1 as "CurrencySelectControlContent", _2 as "currency" }
